module.exports = __webpack_public_path__ + "static/media/mobile_connect@2x.12edc02a.png";